import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { AuthLayout, AuthField } from "@/components/AuthLayout";
import { useAuth } from "@/lib/auth";
import { useT } from "@/lib/i18n";

const SignupPage = () => {
  const t = useT();
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || password.length < 6) { setErr(t("auth.err_invalid")); return; }
    setLoading(true);
    setErr(null);
    try { await signup({ email, password, name }); navigate("/dashboard"); }
    catch (e) { setErr(e.message || t("auth.err_generic")); }
    finally { setLoading(false); }
  };

  return (
    <AuthLayout
      testId="page-signup"
      title={t("auth.create_account")}
      subtitle={<>{t("auth.start_journey")} <span aria-hidden>🍷</span></>}
      footer={<>{t("auth.have_account")} <Link to="/login" className="text-[color:var(--gv-pink)]">{t("cta.log_in")}</Link></>}
    >
      <form onSubmit={onSubmit}>
        <AuthField label={t("auth.full_name")}>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="gv-input" placeholder={t("auth.full_name_placeholder")} data-testid="signup-name" />
        </AuthField>
        <AuthField label={t("auth.email")}>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="gv-input" placeholder="you@email.com" data-testid="signup-email" required />
        </AuthField>
        <AuthField label={t("auth.password")} error={err}>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="gv-input" placeholder={t("auth.min6")} data-testid="signup-password" required />
        </AuthField>
        <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="signup-submit">
          {loading ? `${t("common.loading")}` : <>{t("cta.get_started")} <ArrowRight size={16} /></>}
        </button>
      </form>
    </AuthLayout>
  );
};

export default SignupPage;
